import { BrowserRouter as Router , Routes, Route } from 'react-router-dom';
import './App.css';
import Dashboard from './Components/Dashboard/Dashboard';
import Header from './Components/Partials/Header';
import Footer from './Components/Partials/Footer';
import BookAppointment from './Components/Appointment/BookAppointment';
import MyAppointment from './Components/Appointment/MyAppointment';
import MyAppointmentDetail from './Components/Appointment/MyAppointmentDetail';
import BookAppointment1 from './Components/Appointment/BookAppointment';
import Chats from './Components/Chats/Chats';
import { useEffect } from 'react';
import feather from 'feather-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SuccessPage from './Components/Appointment/SuccessPage';


function App() {
  useEffect(() => {
    feather.replace();
  }, [])

  return (
    <>
    {/* Preloader */}
    {/* <div className="preloader">
      <div className="loader">
        <div className="loader-outter" />
        <div className="loader-inner" />
        <div className="indicator">
          <svg width="16px" height="12px">
            <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6" />
            <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6" />
          </svg>
        </div>
      </div>
    </div> */}
    {/* End Preloader */}
      
    <ToastContainer />
    <Router basename="/">
        <Routes>
          <Route exact path="/" element={<Dashboard />} />
          {/* <Route exact path="/bookappointment" element={<BookAppointment />} /> */}
          <Route exact path="/bookappointment" element={<BookAppointment1 />} />
          <Route exact path="/successpage" element={<SuccessPage />} />
          <Route exact path="/myappointmentlist" element={<MyAppointmentDetail/>} />
          <Route exact path="/myappointment" element={<MyAppointment />} />
          <Route exact path="/chat" element={<Chats/>} />
          </Routes>
      {/* <Footer /> */}
      </Router>
    
  </>
  
  );
}

export default App;
